import React, { useState, useContext, useEffect, useRef } from "react";
import { hasRole } from "../utils/guestUser";
import Slider from "react-slick";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { AuthContext } from "../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import "../Styles/Multicircular-Progress.css";
import { UserContext } from "../context/UserContext";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
import { useNavigate } from "react-router-dom";
function MultipleCircularProgress() {
  const { token, userData } = useContext(AuthContext);
  const sliderRef = useRef(null);
  const currentDate = new Date();
  const currentMonthIndex = new Date().getMonth(); // 0 for Jan, 1 for Feb, etc.

  const { teamsData, usersList, teamNames } = useContext(UserContext);

  const [selectedTeam, setSelectedTeam] = useState(
    (hasRole(userData?.[0]?.DR_Name, "Admin") || hasRole(userData?.[0]?.DR_Name, "Super Admin") || hasRole(userData?.[0]?.DR_Name, "Managing Director"))
      ? ""
      : teamsData[0]?.filter((t) => t.id == userData?.[0]?.STM_Team)?.[0]?.name ?? "",
  );
  const [selectedYear, setSelectedYear] = useState("");
  const [capacityBuget, setcapacityBuget] = useState([]);
  const [budgetData, setBudgetData] = useState([]);

  const [controlData, setControlData] = useState([]);
  const years = Array.from({ length: 10 }, (_, index) => 2020 + index);
  const [filteredTeam, setFilterTeam] = useState(usersList);
  const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);
  const [averageMonthlyValues, setAverageMonthlyValues] = useState([]);
  const [averageYTD, setAverageYTD] = useState(0);
  const currentYear = new Date().getFullYear();
  const [mtd, setMTD] = useState("");

  const [selectedId, setselectedId] = useState(
    (hasRole(userData?.[0]?.DR_Name, "Admin") || hasRole(userData?.[0]?.DR_Name, "Super Admin") || hasRole(userData?.[0]?.DR_Name, "Managing Director")) ? "" : userData?.[0]?.STM_Team,
  );
  if (!years.includes(currentYear)) {
    years.push(currentYear);
    years.sort((a, b) => a - b);
  }
  useEffect(() => {
    setSelectedYear(currentYear);
  }, [currentYear]);

  const handleTeamChange = (e) => {
    const value = e.target.value;
    setSelectedTeam(value);

    const selectedTeam = teamsData[0]?.find((team) => team.name === value);

    setselectedId(selectedTeam?.id || "");
  };

  useEffect(() => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Decs",
    ];

    const calculateTotals = (data) => {
      return months.map((month) => {
        return data.reduce((sum, item) => sum + (Number(item[month]) || 0), 0);
      });
    };
    const filteredDataWithoutTeam = capacityBuget.filter((item) => item.team);
    if (selectedTeam) {
      const filteredData = filteredDataWithoutTeam.filter(
        (item) => item.team === selectedTeam,
      );
      if (filteredData.length > 0) {
        setAverageMonthlyValues(calculateTotals(filteredData));
      } else {
        setAverageMonthlyValues([]);
      }
    } else {
      setAverageMonthlyValues(calculateTotals(filteredDataWithoutTeam));
    }
  }, [selectedTeam, capacityBuget]);

  const handleChange = (event) => {
    setSelectedYear(event.target.value);
  };
  const getMTDForUser = (user) => {
    return getCapacityByUserAndMonth(user, previousMonth); // Ensure previousMonth is correctly set
  };

  const getBudgetedMtdForUser = (user) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Decs",
    ];
    const previousMonthIndex = new Date().getMonth() - 1; // Adjust index
    const previousMonthName = monthNames[previousMonthIndex];
    const budgetDataForUser = budgetData.find(
      (data) => data.empid === user.EM_EmpID,
    );
    return budgetDataForUser
      ? parseFloat(budgetDataForUser[previousMonthName]) || 0
      : 0;
  };

  const fetchForecast = async () => {
    if (!selectedYear) return;
    try {
      const response = await fetch(
        `${userApiUrl}/GetLatestBudget?Year=${selectedYear}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.status === 401) {
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch budget history data");
      }
      const data = await response.json();
      setcapacityBuget(data);
      setBudgetData(data);
      const totalYTD = data.reduce((sum, item) => sum + (parseFloat(item.YTD) || 0), 0);
      const uniqueEmpIds = new Set(data.map((item) => item.empid).filter(id => id));
      const avgYTD = uniqueEmpIds.size > 0 ? totalYTD / uniqueEmpIds.size : 0;
      setAverageYTD(avgYTD);
    } catch (error) {
      console.error("Error fetching budget history data:", error);
    }
  };
  useEffect(() => {
    fetchForecast();
  }, [selectedYear, selectedTeam, token]);
  const [capacityData, setCapacityData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const filteredEmployees = usersList?.filter(
      (user) => user?.STM_Team == selectedId,
    );
    setFilteredEmployeeList(
      filteredEmployees?.map((item) => `'${item["EM_ID"]}'`).join(","),
    );
  }, [selectedId]);
  const currentMonth = currentDate.getMonth() + 1;
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1; // If Jan, go to Dec
  const twoMonthsAgo =
    currentMonth <= 2 ? 12 + (currentMonth - 2) : currentMonth - 2; // Two months before current month
  const getCapacityByUserAndMonth = (user, monthNumber) => {
    const userCapacity = capacityData.find(
      (data) =>
        data.AssginedTo === user.EM_ID &&
        parseInt(data.CreatedMonth) === monthNumber,
    );
    return userCapacity ? parseInt(userCapacity.TotalTime) || 0 : 0;
  };
  const fetchControlData = async () => {
    if (!selectedYear) return;
    const response = await fetch(
      `${taskApiUrl}/GetCapacityUtilisation?CreatedYear=${selectedYear}&AssginedToEmids=${filteredEmployeeList}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!response.ok) return;
    const data = await response.json();
    setControlData(data);
    setCapacityData(data);
    const mtdTotalTime = data
      .filter((item) => parseInt(item.CreatedMonth) === new Date().getMonth() + 1)
      .reduce((sum, item) => sum + (Number(item.TotalTime) || 0), 0);
    const totalEmployees = teamNames?.filter((t) => t.status === true).length;
    setMTD(totalEmployees > 0 ? (mtdTotalTime / totalEmployees).toFixed(2) : "0.00");
  };

  const calculateUtilizationMTD = (user) => {
    const actualMTD = getMTDForUser(user);
    const budgetedMTD = getBudgetedMtdForUser(user);
    return budgetedMTD > 0
      ? ((actualMTD / budgetedMTD) * 100).toFixed(2)
      : "0.00";
  };

  const calculateAverageMTD = () => {
    const usersInTeam = usersList?.filter(
      (user) => user.STM_Team === selectedId,
    );
    if (usersInTeam?.length === 0) return "0.00";

    const totalMTDUtilization = usersInTeam?.reduce(
      (sum, user) => sum + Number(calculateUtilizationMTD(user)),
      0,
    );
    const averageMTD = (totalMTDUtilization / usersInTeam?.length).toFixed(2);

    return averageMTD;
  };

  const averageMTD = calculateAverageMTD();

  const [actualValues, setactualValues] = useState([]);

  useEffect(() => {
    const totalTimes = Array(12).fill(0);
    const counts = Array(12).fill(0);

    controlData.forEach((entry) => {
      const month = parseInt(entry.CreatedMonth) - 1;

      if (month >= 0 && month < 12 && entry.TotalTime) {
        const totalTime = parseInt(entry.TotalTime);
        totalTimes[month] += totalTime;
        counts[month] += 1;
      }
    });

    const averages = totalTimes.map((total) => Math.round(total / 60));

    setactualValues(averages);
  }, [controlData]);

  useEffect(() => {
    fetchControlData();
  }, [selectedYear, filteredEmployeeList, token]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    initialSlide: currentMonthIndex, // 👈 START FROM CURRENT MONTH
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: currentMonthIndex,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: currentMonthIndex,
        },
      },
    ],
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };
  const handleNext = () => {
    sliderRef.current.slickNext();
  };
  const [avgActual, setAvgActual] = useState(null);
  const [avgMonthly, setAvgMonthly] = useState(null);
  const [overallPercentage, setOverallPercentage] = useState(0);
  useEffect(() => {
    updateCircleData();
  }, [averageMonthlyValues, actualValues]);
  const updateCircleData = () => {
    const updatedCircleData = circleData.map((data, index) => {
      const budgeted =
        (averageMonthlyValues && averageMonthlyValues[index]) || 0;
      const actual =
        actualValues &&
        actualValues[index] !== undefined &&
        actualValues[index] !== null
          ? actualValues[index]
          : 0;

      // Calculate percentage with safety checks
      let percentage = 0;
      if (typeof budgeted === "number" && typeof actual === "number") {
        if (budgeted > 0) {
          percentage = Math.min((actual / budgeted) * 100, 100);
        } else if (actual > 0) {
          percentage = 100; // If there's actual work but no budget, show 100%
        }
      }

      return {
        ...data,
        budgeted: budgeted || 0,
        actual: actual || 0,
        percentage: percentage || 0,
      };
    });

    const totalActual = updatedCircleData.reduce(
      (sum, item) => sum + (item.actual || 0),
      0,
    );

    setAvgActual(totalActual);
    setCircleData(updatedCircleData);
  };
  const outerStyles = {
    path: {
      stroke: "rgba(221, 221, 221, 1)",
      strokeLinecap: "square",
    },
    trail: {
      stroke: "white",
      strokeLinecap: "square",
    },
  };
  const innerStyles = {
    path: {
      stroke: "#50145A",
      strokeLinecap: "square",
    },
    trail: {
      stroke: "white",
      strokeLinecap: "square",
    },
  };
  const [circleData, setCircleData] = useState([
    { month: "Jan", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Feb", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Mar", budgeted: 0, actual: 0, percentage: 0 },
    { month: "April", budgeted: 0, actual: 0, percentage: 0 },
    { month: "May", budgeted: 0, actual: 0, percentage: 0 },
    { month: "June", budgeted: 0, actual: 0, percentage: 0 },
    { month: "July", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Aug", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Sep", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Oct", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Nov", budgeted: 0, actual: 0, percentage: 0 },
    { month: "Dec", budgeted: 0, actual: 0, percentage: 0 },
  ]);

  useEffect(() => {
    if (actualValues.length === 12 && averageMonthlyValues.length === 12) {
      const avgActualValue = Math.round(
        actualValues.reduce((sum, value) => sum + value, 0) /
          actualValues.length,
      );
      const totalBudgetedValue = averageMonthlyValues.reduce(
        (sum, value) => sum + value,
        0,
      );

      setAvgActual(avgActualValue);
      setAvgMonthly(totalBudgetedValue);
    }
  }, [actualValues, averageMonthlyValues]);
  useEffect(() => {
    updateCircleData();
  }, [actualValues, averageMonthlyValues]);

  const handleClick = () => {
    navigate("/Capacity2");
  };

  return (
    <div>
      {" "}
      <div className="graph_main_div">
        <div className="graph-card">
          <div className="m_f">
            <div
              className="m_f_h"
              onClick={handleClick}
              style={{ cursor: "pointer" }}
            >
              Capacity Utilization
            </div>
            <div className="m_f_drop_down">
              <div className="m_f_drop_down-new">
                <Select
                  labelId="year-select-label"
                  value={selectedYear}
                  onChange={handleChange}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    Select Year
                  </MenuItem>
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
                {(hasRole(userData?.[0]?.DR_Name, "Admin") || hasRole(userData?.[0]?.DR_Name, "Super Admin") || hasRole(userData?.[0]?.DR_Name, "Managing Director") || !hasRole(userData?.[0]?.DR_Name, "Consultant")) && (
                  <Select
                    fullWidth
                    value={selectedTeam}
                    onChange={handleTeamChange}
                    displayEmpty
                  >
                    <MenuItem value="">All Teams</MenuItem>
                    {teamsData[0]
                      ?.filter(
                        (team) => team?.status === true && team?.type === "T",
                      )
                      ?.map((data) => (
                        <MenuItem key={data.id} value={data.name}>
                          {data.name}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              </div>
            </div>
          </div>
          <div className="m_f_s_h">
            {avgMonthly} <span className="s-m-c-p">/ </span>
            <span className="s-m-350"> {avgActual}</span>
          </div>
          <div className="slider-wrapper">
            <FontAwesomeIcon
              icon={faCaretLeft}
              className="arrow-left"
              onClick={handlePrev}
            />

            <Slider {...settings} ref={sliderRef}>
              {circleData.map((data, index) => {
                // Ensure data exists
                const safeData = data || {};
                const percentage = safeData.percentage || 0;
                const actual = safeData.actual || 0;
                const budgeted = safeData.budgeted || 0;
                const month = safeData.month || "";

                return (
                  <div
                    key={index}
                    className={`circle-data circle-data-h-${index + 1}`}
                  >
                    <div className="skill">
                      <div className="container">
                        <div style={{ width: "100px" }}>
                          <div
                            style={{
                              position: "relative",
                              width: "152px",
                              height: "110px",
                            }}
                          >
                            {/* Outer circle for budgeted (100% scale) */}
                            <CircularProgressbar
                              value={100}
                              className="circle-1"
                              styles={{
                                path: {
                                  stroke: "rgba(221, 221, 221, 1)",
                                  strokeLinecap: "square",
                                },
                                trail: {
                                  stroke: "white",
                                  strokeLinecap: "square",
                                },
                              }}
                            />

                            <div
                              style={{
                                position: "absolute",
                                top: "49%",
                                left: "47%",
                                transform: "translate(-50%, -50%)",
                                width: "80%",
                                height: "80%",
                              }}
                            >
                              {/* Inner circle for actual percentage */}
                              <CircularProgressbar
                                value={percentage}
                                className="circle-2"
                                styles={{
                                  path: {
                                    stroke: "#50145A",
                                    strokeLinecap: "square",
                                  },
                                  trail: {
                                    stroke: "white",
                                    strokeLinecap: "square",
                                  },
                                }}
                              />

                              {/* Percentage text in the center */}
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  textAlign: "center",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#50145A",
                                }}
                              >
                                {typeof percentage === "number"
                                  ? percentage.toFixed(1) + "%"
                                  : "0%"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="circle-data-info">
                      <div className="mon">{month}</div>
                      <div className="act">Actual: {actual}</div>
                      <div className="bug">Budgeted: {budgeted}</div>
                      {/* <div className="perc">
                        Utilization:{" "}
                        {typeof percentage === "number"
                          ? percentage.toFixed(1) + "%"
                          : "0%"}
                      </div> */}
                    </div>
                  </div>
                );
              })}
            </Slider>

            <FontAwesomeIcon
              icon={faCaretRight}
              className="arrow-right"
              onClick={handleNext}
            />
          </div>
          <div className="gc-dash-footer">
            <div className="gc-dash-footer-data">
              Capacity Utilization for{" "}
              <span className="gc-dash-footer-spam">
                {" "}
                YTD: {averageYTD.toFixed(2)}% MTD: {mtd}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultipleCircularProgress;
